import React, { useState } from 'react';
import { Search, Play, X } from 'lucide-react';

interface Song {
  id: string;
  title: string;
  artist: string;
  album: string;
  albumCover: string;
}

interface SongPickerProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (song: Song) => void;
}

const mockSongs: Song[] = [
  {
    id: '1',
    title: 'Midnight City',
    artist: 'The Indie Waves',
    album: 'Night Dreams',
    albumCover: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=100&h=100&fit=crop'
  },
  {
    id: '2',
    title: 'Ocean Breeze',
    artist: 'Coastal Vibes',
    album: 'Summer Days',
    albumCover: 'https://images.unsplash.com/photo-1520962880247-cfaf541c8724?w=100&h=100&fit=crop'
  },
  {
    id: '3',
    title: 'Urban Lights',
    artist: 'City Sound',
    album: 'Metropolitan',
    albumCover: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=100&h=100&fit=crop'
  }
];

function SongPicker({ isOpen, onClose, onSelect }: SongPickerProps) {
  const [searchQuery, setSearchQuery] = useState('');
  
  const filteredSongs = mockSongs.filter(song => 
    song.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    song.artist.toLowerCase().includes(searchQuery.toLowerCase()) ||
    song.album.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-md">
        <div className="p-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-semibold">Choose a song</h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="h-5 w-5 text-gray-500" />
          </button>
        </div>
        
        <div className="p-4">
          <div className="relative mb-4">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search songs..."
              className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
          </div>

          <div className="space-y-2 max-h-96 overflow-y-auto">
            {filteredSongs.map(song => (
              <button
                key={song.id}
                onClick={() => {
                  onSelect(song);
                  onClose();
                }}
                className="w-full p-3 flex items-center space-x-3 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <img
                  src={song.albumCover}
                  alt={song.album}
                  className="w-12 h-12 rounded-md object-cover"
                />
                <div className="flex-1 text-left">
                  <p className="font-medium">{song.title}</p>
                  <p className="text-sm text-gray-600">{song.artist}</p>
                  <p className="text-xs text-gray-500">{song.album}</p>
                </div>
                <Play className="h-5 w-5 text-gray-400" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SongPicker;